import { render, staticRenderFns } from "./SlidePromoFlexible.vue?vue&type=template&id=5d95c7d8&scoped=true&"
import script from "./SlidePromoFlexible.vue?vue&type=script&lang=js&"
export * from "./SlidePromoFlexible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d95c7d8",
  null
  
)

export default component.exports